(function ($) {
  $(".desktopslider").slick({
    arrows: true,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    prevArrow: $(".button_prev_desk"),
    nextArrow: $(".button_next_desk"),
    adaptiveHeight: true,
  });

  $(".mobileSlider").slick({
    arrows: true,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    prevArrow: $(".button_prev_mob"),
    nextArrow: $(".button_next_mob"),
    adaptiveHeight: true,
  });
})(jQuery);